import Reveal from "@/components/Reveal";
import Marquee from "@/components/Marquee";

const CHAPTERS = [
  {
    n: "01",
    title: "THE PATH",
    body: [
      "aligndept started with a pattern nobody could explain — the same numbers, showing up in the same week, on clocks, receipts, license plates. 1:11. 2:22. Most people shrug. We started paying attention.",
      "The brand is built on a simple position: everyone is handed a map, and most people follow it. aligndept is for the ones who fold the map, put it away, and walk by signal instead.",
    ],
  },
  {
    n: "02",
    title: "THE FREQUENCY",
    body: [
      "Angel numbers aren't decoration here. They're a quiet language — 111 for beginnings, 222 for trust, 333 for growth, 444 for protection, 555 for change. Every garment carries one. Not loud. Not mystical. Just a mark for people who notice things twice.",
      "We don't tell you what to believe. We make heavy, honest clothing for people who already believe in their own direction.",
    ],
  },
  {
    n: "03",
    title: "THE ORDER",
    body: [
      "Nothing arrives out of sequence. The delay was the route. The detour was the door. Every piece is garment-washed and hand-distressed because nothing real arrives clean — it arrives worn, marked, and exactly on time.",
      "Right place. Right time. Stay aligned.",
    ],
  },
];

export default function Story() {
  return (
    <div data-testid="story-page" className="pt-24">
      <section className="relative overflow-hidden px-5 py-20 sm:px-8">
        <span className="pointer-events-none absolute -right-6 bottom-0 select-none font-display text-[13rem] font-extrabold leading-none text-bone/[0.04]">222</span>
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.35em] text-fade">OUR STORY</p>
          <h1 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tight text-bone sm:text-7xl">
            Nothing happens
            <br />
            by coincidence.
          </h1>
          <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-neutral-400 sm:text-lg">
            aligndept is a streetwear label built around alignment — the idea that individuality isn't an accident, and neither is the path you're on.
          </p>
        </Reveal>
      </section>

      <Marquee items={["TRUST THE PROCESS", "NO COINCIDENCES", "STAY ALIGNED", "RIGHT PLACE. RIGHT TIME."]} />

      <section className="mx-auto max-w-4xl px-5 py-24 sm:px-8">
        {CHAPTERS.map((c) => (
          <Reveal key={c.n} className="border-t border-white/10 py-14">
            <div data-testid={`story-chapter-${c.n}`} className="grid gap-6 sm:grid-cols-12">
              <div className="sm:col-span-3">
                <span className="font-display text-5xl font-extrabold text-bone/20">{c.n}</span>
                <h2 className="mt-2 font-display text-xl font-extrabold uppercase tracking-tight text-bone">{c.title}</h2>
              </div>
              <div className="space-y-5 sm:col-span-9">
                {c.body.map((p, i) => (
                  <p key={i} className="text-base font-light leading-relaxed text-neutral-400">
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-white/10 px-5 py-24 text-center sm:px-8">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.4em] text-fade">LOS ANGELES</p>
          <p className="mx-auto mt-8 max-w-3xl font-display text-3xl font-light italic leading-snug tracking-tight text-neutral-200 sm:text-5xl">
            “You didn't find this page by accident.”
          </p>
        </Reveal>
      </section>
    </div>
  );
}
